import styled from 'styled-components';

interface StyledMessageProps {
  $isUser: boolean;
  $pending?: boolean;
}

export const StyledMessage = styled.div<StyledMessageProps>`
  align-self: flex-start;
  max-width: 85%;
  padding: 12px 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.grey12};
  overflow-wrap: break-word;
  white-space: pre-wrap;
  background-color: ${({ theme }) => theme.color.grey95};
  border-radius: 16px 16px 16px 4px;

  ${({ $isUser, theme }) =>
    $isUser &&
    `
    align-self: flex-end;
    color: ${theme.color.white};
    background-color: ${theme.color.violet64};
    border-radius: 16px 16px 4px;
  `}

  ${({ $pending }) =>
    $pending &&
    `
    display: flex;
    align-items: center;
  `}
`;

export const StyledMarkdown = styled.div`
  white-space: normal;

  p,
  ul,
  ol,
  pre,
  blockquote {
    margin: 0 0 8px;
  }

  ul,
  ol {
    padding-left: 20px;
  }

  li {
    margin-bottom: 4px;
  }

  pre {
    padding: 12px 14px;
    overflow-x: auto;
    background-color: ${({ theme }) => theme.color.grey88};
    border-radius: 8px;
  }

  code {
    padding: 2px 6px;
    font-size: 0.9em;
    background-color: ${({ theme }) => theme.color.grey88};
    border-radius: 4px;
  }

  pre code {
    padding: 0;
    background: none;
  }

  a {
    color: ${({ theme }) => theme.color.violet64};
    text-decoration: underline;
  }

  p:last-child,
  ul:last-child,
  ol:last-child,
  pre:last-child,
  blockquote:last-child {
    margin-bottom: 0;
  }
`;
